import { render } from "./CustomerForgotPassword.vue?vue&type=template&id=98e31fa4"
import script from "./CustomerForgotPassword.vue?vue&type=script&lang=js"
export * from "./CustomerForgotPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__